export const TYPES = {
  SELECT_ALL_JOB_SUCCESS: "job/SELECT_ALL_JOB_SUCCESS",
  GET_JOB_LIST_SUCCESS: "job/GET_JOB_LIST_SUCCESS",

  SELECT_ALL_INCOME_SUCCESS: "job/SELECT_ALL_INCOME_SUCCESS",
  GET_STAFF_BY_IDS_SUCCESS: "job/GET_STAFF_BY_IDS_SUCCESS",
  
  GET_JOB_DETAIL_BY_ID_SUCCESS: "job/GET_JOB_DETAIL_BY_ID_SUCCESS",
};
